export const LOCALE_STORAGE_KEY = 'preferred-locale';
